function FixtureCard({
  fixture,
  score,
  locked,
  isSaving,
  statusMessage,
  onScoreChange,
  onSave,
}) {
  const formatKickoff = (kickoffUtc) => {
    // Convert UTC to user's local timezone
    const date = new Date(kickoffUtc);
    return date.toLocaleString([], {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const getStatusConfig = () => {
    if (isSaving) {
      return { text: "Saving...", className: "bg-sky-100 text-sky-700" };
    }
    if (statusMessage === "Saved") {
      return { text: "Saved", className: "bg-emerald-100 text-emerald-700" };
    }
    if (statusMessage === "Enter both scores") {
      return { text: "Enter both scores", className: "bg-amber-100 text-amber-700" };
    }
    if (statusMessage) {
      return { text: statusMessage, className: "bg-rose-100 text-rose-700" };
    }
    return null;
  };

  const statusConfig = getStatusConfig();

  const scoreInputClass =
    "h-12 w-12 sm:h-14 sm:w-14 rounded-2xl border border-slate-300 bg-white text-center text-base sm:text-lg font-semibold outline-none transition focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100 disabled:bg-slate-100 disabled:text-slate-400 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none";

  return (
    <div className="rounded-3xl bg-white p-4 sm:p-5 shadow-sm ring-1 ring-slate-200">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Kickoff
          </p>
          <p className="mt-1 text-sm text-slate-700">
            {formatKickoff(fixture.kickoffUtc)}
          </p>
          {fixture.extraInfo && (
            <p className="mt-2 text-xs font-semibold text-slate-600 bg-slate-100 inline-block px-2 py-1 rounded">
              {fixture.extraInfo}
            </p>
          )}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {statusConfig && (
            <span
              className={`inline-flex rounded-full px-2 py-1 sm:px-3 text-xs font-semibold ${statusConfig.className}`}
            >
              {statusConfig.text}
            </span>
          )}

          <span
            className={`inline-flex rounded-full px-2 py-1 sm:px-3 text-xs font-semibold ${
              locked
                ? "bg-rose-100 text-rose-700"
                : "bg-emerald-100 text-emerald-700"
            }`}
          >
            {locked ? "Locked" : "Open"}
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-4 sm:gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="grid flex-1 grid-cols-[1fr_auto_1fr] items-center gap-2 sm:gap-3">
          <div className="text-right min-w-0">
            <p className="text-base sm:text-lg font-semibold tracking-tight text-slate-900 truncate">
              {fixture.homeTeamName}
            </p>
            <p className="text-xs sm:text-sm text-slate-500 truncate">{fixture.homeTeamShortName}</p>
          </div>

          <div className="flex items-center justify-center gap-1 sm:gap-2">
            <input
              type="number"
              min="0"
              inputMode="numeric"
              pattern="[0-9]*"
              value={score?.home ?? ""}
              onChange={(e) => onScoreChange("home", e.target.value)}
              disabled={locked}
              className={scoreInputClass}
            />

            <span className="text-base sm:text-lg font-semibold text-slate-400">-</span>

            <input
              type="number"
              min="0"
              inputMode="numeric"
              pattern="[0-9]*"
              value={score?.away ?? ""}
              onChange={(e) => onScoreChange("away", e.target.value)}
              disabled={locked}
              className={scoreInputClass}
            />
          </div>

          <div className="text-left min-w-0">
            <p className="text-base sm:text-lg font-semibold tracking-tight text-slate-900 truncate">
              {fixture.awayTeamName}
            </p>
            <p className="text-xs sm:text-sm text-slate-500 truncate">{fixture.awayTeamShortName}</p>
          </div>
        </div>

        <div className="w-full lg:w-40">
          <button
            onClick={onSave}
            disabled={locked || isSaving}
            className="inline-flex w-full items-center justify-center rounded-2xl bg-slate-900 px-3 sm:px-4 py-2.5 sm:py-3 text-xs sm:text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isSaving ? "Saving..." : "Save Pick"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FixtureCard;
